import { combineReducers } from 'redux'
import AuthReducer from './AuthReducer'
import DadosReducer from './DadosReducer'

export default combineReducers({
    auth: AuthReducer,
    dados: DadosReducer
})
